import { api } from "../../../api/apiSlice";

// Branch-wise master (handoff §9.9, added 2026-08-19) - React-owned despite
// feeding a Flutter-only workflow (Sales Enquiry service picker, §17.10),
// same category as Area/Department masters. serviceKind (GUARDS/ALARMS/
// OTHER) is set only at Create, never part of the Update body - every
// branch has at most one GUARDS and one ALARMS row, both server-protected
// from deletion (rename/activate-deactivate still allowed on them).
export const serviceTypesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getServiceTypes: builder.query({
      query: (params) => ({ url: "/masters/service-types", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((s) => ({ type: "MasterServiceTypes", id: s.serviceTypeId })),
              { type: "MasterServiceTypes", id: "LIST" },
            ]
          : [{ type: "MasterServiceTypes", id: "LIST" }],
    }),
    createServiceType: builder.mutation({
      query: (body) => ({ url: "/masters/service-types", method: "POST", data: body }),
      invalidatesTags: [{ type: "MasterServiceTypes", id: "LIST" }],
    }),
    updateServiceType: builder.mutation({
      query: ({ serviceTypeId, ...body }) => ({
        url: `/masters/service-types/${serviceTypeId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "MasterServiceTypes", id: "LIST" }],
    }),
    deleteServiceType: builder.mutation({
      query: (serviceTypeId) => ({
        url: `/masters/service-types/${serviceTypeId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "MasterServiceTypes", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetServiceTypesQuery,
  useCreateServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,
} = serviceTypesApi;
